import {
    HATCH_GAME_ROUTE,
    HATCH_GAME_ANSWER_ROUTE,
    SHARE_CHALLENGE_CALENDAR_ROUTE,
    CALENDAR_PLAYER_SHARING,
    GET_CALENDAR_PLAYER_COVER
} from './constants';

import http from '../../../utils/httpService';
import { getCookie } from '../../../utils/cookieService';

/**
 *
 * @param hatchID
 * @param resolve
 */
const requestHatchGameStart = ( hatchID, country, resolve ) => {
    const route = `${ HATCH_GAME_ROUTE }/${ hatchID }`;
    const body = { uuid: getCookie( 'uuid' ), country: country };
    return http.request( route, 'POST', body, false, resolve );
};
/**
 *
 * @param hatchID
 * @param gameID
 * @param answerObject
 */
const requestHatchQuestionAnswer = ( hatchID, gameID, answerObject ) => {
    const uuid = getCookie( 'uuid' );
    const route = `${ HATCH_GAME_ANSWER_ROUTE }/${ hatchID }`;
    const body = {
        uuid: uuid,
        game_id: gameID,
        answer: answerObject
    };
    return http.request( route, 'POST', body );
};

/**
 *
 * @param id
 * @param hatchID
 * @param shareableType
 */
const requestShareChallengeCalendar = ( id, hatchID, shareableType ) => {
    const body = {
        initiator_id: hatchID,
        shareable_type: shareableType,
    };
    const uuid = getCookie( 'uuid' );
    const route = `${ SHARE_CHALLENGE_CALENDAR_ROUTE }/${ id }`;
    return http.request( route, 'POST', { ...body, uuid_front: uuid } );
};

/**
 *
 * @param data
 */
const requestSharingsTags = ( data ) => {
    return http.request( CALENDAR_PLAYER_SHARING, 'POST', data );
};

/**
 *
 * @param id
 * @param data
 * @returns {*}
 */
const requestPlayerCalendarCover = ( id, data ) => {
    const route = `${ GET_CALENDAR_PLAYER_COVER }/${ id }`;
    const body = { uuid_front: getCookie( 'uuid' ), ...data };
    return http.request( route, 'POST', body );
};

export {
    requestHatchQuestionAnswer,
    requestHatchGameStart,
    requestShareChallengeCalendar,
    requestSharingsTags,
    requestPlayerCalendarCover
};
